import { Api, Cable } from '@mui/icons-material';


const API_SWAGGER_URL = process.env.REACT_APP_API_SWAGGER_URL
const TAXII_SWAGGER_URL = process.env.REACT_APP_TAXII_SWAGGER_URL

export const integrationConfig = [
  {
    icon: Api,
    name: 'API Docs',
    description: 'API documentation',
    url: API_SWAGGER_URL,
  },
  {
    icon: Api,
    name: 'TAXII API Docs',
    description: 'TAXII API documentation',
    url: TAXII_SWAGGER_URL,
  },
  {
    icon: Cable,
    name: 'OpenCTI Connector',
    description: 'OpenCTI Connector',
    url: 'https://github.com/OpenCTI-Platform/connectors/tree/master/external-import/dogesec-stixify',
  },
]